<script>
import ContactMixin from "../mixins/Contact";
import ConfigurationMixin from "../mixins/Configuration";

export default {
    props: {
        configuration: {
            type: Object,
            required: true,
        },
    },

    inject: ["locale"],

    mixins: [ContactMixin, ConfigurationMixin],

    data: function () {
        return {
            contact: {
                email: null,
                type: 0, // Lead
            },
            errors: {
                errors: {},
                message: null,
            },
            consents: {
                privacy: false,
                marketing: false,
            },
            privacyLink: JSON.parse(
                document.getElementById("configuratorConfiguration").textContent
            ).company.privacyPolicyLink, // layouts/configurator.blade.php
        };
    },

    methods: {
        onSubmit(type) {
            this.$showSpinner();
            this.createContact(this.contact)
                .then((resp) => {
                    let configurationData = {
                        model_id: this.configuration.model.id,
                        contact_id: resp.data.id,
                        engine_id: this.configuration.engine.id,
                        option_ids: this.configuration.options.map((o) => o.id),
                        privacy_consent: this.consents.privacy,
                        marketing_consent: this.consents.marketing,
                        create_offer: this.isOfferRequest,
                        locale: this.locale,
                    };
                    return this.createConfiguration(configurationData);
                })
                .then((resp) => {
                    this.$hideSpinner();
                    this.onSave(resp.data, type);
                })
                .catch((error) => {
                    this.$hideSpinner();
                    if (error.response && error.response.status == 422) {
                        this.errors = error.response.data;
                    } else {
                        this.errors.message = this.$t("unexpected_error");
                        this.errors.errors = {};
                    }
                });
        },

        onSave(data, type) {
            this.$router.push({
                name: "configuration",
                params: { id: data.id },
                query: {
                    thankyou: type,
                    locale: this.locale,
                },
            });
        },

        onClose() {
            this.$emit("close");
        },
    },
};
</script>
